import React, { useState, useEffect } from 'react';
import { useBetaData } from '../../../contexts/BetaDataContext';
import PhaseItem from './PhaseItem';
import './PhaseListPanel.scss';

const PhaseListPanel = ({ projectId, initialPhaseId = null, onEditPhase }) => {
  const { projectPhases, refreshProjectPhases } = useBetaData();
  const [loading, setLoading] = useState(true);
  const [expandedIds, setExpandedIds] = useState(new Set());

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await refreshProjectPhases(projectId);
      setLoading(false);
    };
    load();
  }, [projectId, refreshProjectPhases]);

  // 從 Milestone 跳轉過來時，自動展開指定的 Phase
  useEffect(() => {
    if (initialPhaseId && !loading) {
      setExpandedIds((prev) => new Set(prev).add(initialPhaseId));
    }
  }, [initialPhaseId, loading]);

  const rawPhases = projectPhases[projectId] || [];

  // 所有交付項目都 QA pass 的 Phase 往下沉
  const phases = [...rawPhases].sort((a, b) => {
    const aAllDone = (a.deliverables || []).length > 0 &&
      (a.deliverables || []).every((d) => d.qa_status === 'success');
    const bAllDone = (b.deliverables || []).length > 0 &&
      (b.deliverables || []).every((d) => d.qa_status === 'success');
    if (aAllDone === bAllDone) return 0;
    return aAllDone ? 1 : -1;
  });

  if (loading) {
    return (
      <div className="phase-list-panel">
        <div className="phase-list-loading">
          {[1, 2, 3].map((i) => (
            <div key={i} className="skeleton-phase">
              <div className="skeleton skeleton-bar" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="phase-list-panel">
      {phases.length === 0 ? (
        <div className="phase-list-empty">
          <div className="empty-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="#ccc" strokeWidth="1.5">
              <rect x="8" y="12" width="32" height="8" rx="2" />
              <rect x="8" y="24" width="32" height="8" rx="2" />
              <rect x="8" y="36" width="20" height="8" rx="2" strokeDasharray="4 2" />
            </svg>
          </div>
          <p className="empty-title">尚無階段規劃</p>
          <p className="empty-desc">建立階段來規劃專案的開發流程和交付項目</p>
        </div>
      ) : (
        <div className="phase-list-body">
          {phases.map((phase) => (
            <PhaseItem
              key={phase.id}
              phase={phase}
              projectId={projectId}
              onEdit={onEditPhase}
              expanded={expandedIds.has(phase.id)}
              onToggleExpand={() => setExpandedIds((prev) => {
                const next = new Set(prev);
                if (next.has(phase.id)) next.delete(phase.id);
                else next.add(phase.id);
                return next;
              })}
            />
          ))}
        </div>
      )}

    </div>
  );
};

export default PhaseListPanel;
